<template>
  <EChartsLine
    :xData="getXData"
    :series="getSeries"
    :titleConfig="titleConfig"
    :isLoading="isLoading"
    tooltipPostfix=" %"
    :valueFractionDigits="1"
  />
</template>

<script>
  //TODO: перевести на TS
  import Constants, { DATE_FORMATS } from '@/common/constants';
  import { getRuFormattedDate } from '@/common/utils/dates';

  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';

  import Api from '../../api';

  export default {
    name: 'M2InflationChart',
    components: { EChartsLine },
    props: {
      countryId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        chartData: [],
        isLoading: false,
        titleConfig: {
          text: 'Инфляция и прирост денежной массы М2',
          tooltipContent: Constants.tooltipLegendCommon,
        },
      };
    },
    computed: {
      getXData() {
        return this.chartData.map((item) => getRuFormattedDate(item.period, DATE_FORMATS['MMM, YYYY']));
      },
      getSeries() {
        if (!this.chartData.length) return [];

        return [
          {
            name: 'М2, % г/г',
            data: this.chartData.map((item) => item.m2),
            color: '#277cc5',
          },
          {
            name: 'Инфляция, % г/г',
            data: this.chartData.map((item) => item.inflation),
            color: '#73EA48',
          },
        ];
      },
    },
    created() {
      this.loadChart();
    },
    methods: {
      async loadChart() {
        this.isLoading = true;
        try {
          const response = await Api.getMonetaryM2Inflation(this.countryId);
          this.chartData = response.data ?? [];
        } catch {
          this.chartData = [];
        } finally {
          this.isLoading = false;
        }
      },
    },
    watch: {
      countryId() {
        this.loadChart();
      },
    },
  };
</script>
